import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

import { Button } from '@karehero/llama/components/atoms/Button/Button';

import { inFrameDialogProps } from '@/designs-dev/device/inFrameDialog';
import { type Shortlists } from '@/cam-admin/paywall/useShortlists';
import { PUBLISH_HOMES } from '@/cam-admin/paywall/Shortlist.content';

// Publishing a care home list, behind one sentence.
//
// The dom modal next door is a form: publishing is the send there, so a CAM
// reads and edits the words before they leave. Nothing leaves on a care home
// list — the homes were rung days ago — so this is a confirm and not a second
// version of that screen. What it has to say is the thing the two kinds of list
// disagree about: a dom list going live shows the family nobody until somebody
// pays, and this one shows them everybody at once.
//
// No close cross in the title. The dom modal has one because it holds work a CAM
// might come back to; there is nothing here to preserve, so Cancel is the way out
// and one way out is enough.
const PublishHomes = ({
  shortlists,
  inFrame,
}: {
  shortlists: Shortlists;
  inFrame?: boolean;
}) => {
  const { isHomePublishOpen, cancelHomePublish, publishWithoutSending } =
    shortlists;

  if (!isHomePublishOpen) return null;

  return (
    <Dialog
      open
      onClose={cancelHomePublish}
      maxWidth='xs'
      fullWidth
      {...(inFrame ? inFrameDialogProps : {})}
    >
      <DialogTitle>
        <Typography variant='h3' color='primary.main'>
          {PUBLISH_HOMES.title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant='subtitle1'>{PUBLISH_HOMES.body}</Typography>
      </DialogContent>

      <DialogActions>
        <Stack sx={{ alignItems: 'center' }} direction='row' spacing={2}>
          <Button
            ariaLabel={PUBLISH_HOMES.cancel}
            variant='secondary'
            onPress={cancelHomePublish}
          >
            {PUBLISH_HOMES.cancel}
          </Button>
          <Button
            ariaLabel={PUBLISH_HOMES.cta}
            variant='primary'
            onPress={publishWithoutSending}
          >
            {PUBLISH_HOMES.cta}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

PublishHomes.displayName = 'PublishHomes';
export default PublishHomes;
